import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function WebsiteDevelopment() {
    return (

        <div className="inner-page about contact-page servi-ce-details">

            <Header />


            <div className="rts-breadcrumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="baread-crumb-main-wrapper pt--100">
                                <div className="inner">
                                    <h1 className="title rts_hero__title">Graphic Designing</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="service-details-area rts-section-gapTop bg-dark-s">
                <div className="container-150">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="main-page-title-service-left-area">
                                <div className="left">
                                    <h1 className="title-page rts_hero__title">
                                        Creating the Best Visual Design<br /> that stands out
                                    </h1>
                                    <div className="bottom-content">
                                        <p className="disc">
                                            Visuals speak more than words, and at Warmonks, we know that powerful designing is the right way to do things. Here, our graphical designing<br /> services provide the visual beauty of your company's vision so that you create the best business and market that is needed now. At Warmonks,<br /> we create logo, well-designed social media content, stunning marketing materials through our expert and talented designers.</p>                                        {/* <div className="check-area-main-sd">
                                            <div className="single-check">
                                                <i className="fa-light fa-check"></i>
                                                <p>Content & Software Engineering</p>
                                            </div>
                                            <div className="single-check">
                                                <i className="fa-light fa-check"></i>
                                                <p>Artificial Intelligence and Learning New</p>
                                            </div>
                                            <div className="single-check">
                                                <i className="fa-light fa-check"></i>
                                                <p>Digital Service Platform</p>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="right">
                                    <div className="top-center-image circle-speen rts-scroll-down-circle-wrapper-3">
                                        <a href="#" className="speen-shape scroll-down-circle-3">
                                            <svg className="uni-circle-text-path uk-text-secondary uni-animation-spin"
                                                viewBox="0 0 100 100" width="180" height="180">
                                                <defs>
                                                    <path id="circle"
                                                        d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" />

                                                </defs>
                                                <text font-size="11.75">
                                                    <textPath xlinkHref="#circle">Project SHowcase • Project SHowcase •
                                                    </textPath>
                                                </text>
                                            </svg>
                                            <i className="fa-solid fa-star-sharp"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row pt--80 pt_md--10 pt_sm--0">
                        <div className="col-xl-9 col-lg-12 pr--60 pr_md--15 pr_sm--10 pb_sm--30">

                            <div className="service-details-left">
                                <div className="thumbnaiul-large">
                                    <img src="assets/images/service/04.jpg" alt="service-details" />
                                </div>
                            </div>

                            <div className="single-para-title-service-details mt--40">
                                <h3 className="title">Our Sevices</h3>
                                {<div className="check-area-main-sd">
                                    <div className="single-check">
                                        <i className="fa-light fa-check"></i>
                                        <p>Brand Identity Design : Develop a strong and cohesive brand identity with our custom logos, business cards, and brand guidelines services.  </p>
                                    </div>
                                    <div className="single-check"> 
                                        <i className="fa-light fa-check"></i>
                                        <p>Social Media Graphics: Elevate your online presence with attention-grabbing visuals designed to engage and attract your audience. </p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-check"></i>
                                        <p>Marketing Collaterals: Create stunning brochures, flyers, banners, and other materials that make your brand memorable.</p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-check"></i>
                                        <p>Website and App UI/UX Design:   We Design user-friendly and stunning user interfaces that improve user experience across digital channels.</p>
                                    </div>
                                    <div className="single-check">
                                        <i className="fa-light fa-check"></i>
                                        <p>Custom Illustrations and Infographics  Bring your story to life visually through custom illustrations and infographics that make complex ideas easy to understand.</p>
                                    </div>
                                </div>}
                            </div>

                            <div className="single-para-title-service-details mt--40">
                                <h3 className="title">Warmonks: Your Creative Partner in Graphic Design</h3>
                                <p className="disc">
                                    Warmonks transforms your ideas into designs. Whether it is a new startup looking for brand identity or an established one looking to recreate designs, creative solutions that drive results are delivered to you. From excellence to innovative thinking and from customer-centric approach to ensuring the brand leaves a great impression, we at Warmonks ensure to create visuals inspiring and resonating.</p>
                            </div>

                            {/* <div className="image-thumbnail-2-service-d mt--50">
                                <div className="row g-4">
                                    <div className="col-lg-5">
                                        <div className="thumbnail-service">
                                            <img src="assets/images/service/05.jpg" alt="service" />
                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="thumbnail-service">
                                            <img src="assets/images/service/06.jpg" alt="service" />
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            <div className="faq-section-start-left-img mt--80">
                                <div className="row">
                                    <div className="col-xl-6 col-lg-12">
                                        <div className="thumbnail">
                                            <img src="assets/images/service/07.png" alt="service_images" />
                                        </div>
                                    </div>
                                    <div className="col-xl-6 col-lg-12 pl--50 pl_lg--0">

                                        <div className="service-details-accordion-area">
                                            <h3 className="title">Why Graphic Designing from Warmonks?</h3>
                                            <div className="accordion" id="accordionExample">
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingOne">
                                                        <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                                            data-bs-target="#collapseOne" aria-expanded="true"
                                                            aria-controls="collapseOne">
                                                            Creative Excellence
                                                        </button>
                                                    </h2>
                                                    <div id="collapseOne" className="accordion-collapse collapse show"
                                                        aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>Our designers have the creativity, innovation, and professionalism that can go into every design that is made; the designs produced are ones to aspire to.  </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingTwo">
                                                        <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapseTwo"
                                                            aria-expanded="false" aria-controls="collapseTwo">
                                                            Tailored Solutions
                                                        </button>
                                                    </h2>
                                                    <div id="collapseTwo" className="accordion-collapse collapse"
                                                        aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>We find out what makes your brand special, what's its personality and who its audience is, designing something that aligns with those goals.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingThree">
                                                        <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapseThree"
                                                            aria-expanded="false" aria-controls="collapseThree">
                                                            From Branding and Advertising
                                                        </button>
                                                    </h2>
                                                    <div id="collapseThree" className="accordion-collapse collapse"
                                                        aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>All kinds of graphic designing services under one roof, ranging from branding and advertising to digital and print design.  </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header" id="headingFour">
                                                        <button className="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse" data-bs-target="#collapseFour"
                                                            aria-expanded="false" aria-controls="collapseFour">
                                                            Efficiency with Timeliness
                                                        </button>
                                                    </h2>
                                                    <div id="collapseFour" className="accordion-collapse collapse"
                                                        aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                                        <div className="accordion-body">
                                                            <p>With a focus on efficiency, we ensure your deadlines are met with quality designs.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-12 mt_lg--50 rts-sticky-column-item">
                            <div className="theiaStickySidebar">
                                <div className="rts-single-wized Categories">
                                    <div className="wized-header">
                                        <h5 className="title">
                                            All Services
                                        </h5>
                                    </div>
                                    <div className="wized-body">

                                        <ul className="single-categories">
                                            <li><a href="/websitedevelopment">Website Development <i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/appdevelopment">App Development<i className="far fa-long-arrow-right"></i></a>
                                            </li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/ecommercedevelopment">Ecommerce Development<i className="far fa-long-arrow-right"></i></a>
                                            </li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/digitalmarketing">Digital Marketing<i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/seo">SEO<i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                        <ul className="single-categories">
                                            <li><a href="/graphicsdesigning">Graphic Designing <i className="far fa-long-arrow-right"></i></a></li>
                                        </ul>

                                    </div>
                                </div>
                                {/* <div className="rts-single-wized Categories">
                                    <div className="wized-header">
                                        <h5 className="title">
                                            Let's start new project.
                                        </h5>
                                    </div>
                                    <div className="wized-body">
                                        <form className="service-details-form" action="#">
                                            <input type="text" placeholder="Your name" />
                                            <input type="text" placeholder="Phone number" />
                                            <textarea placeholder="Message"></textarea>
                                            <button>Start Project</button>
                                        </form>
                                    </div>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <Footer />

            <div className="loading-screen" id="loading-screen">
                <span className="bar top-bar"></span>
                <span className="bar down-bar"></span>
                <span className="progress-line"></span>
                <span className="loading-counter"> </span>
            </div>


            <div className="bg-noise"></div>



            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
                </svg>
            </div>

            <div className="rts-cursor cursor-outer" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor"></span>
            </div>
            <div className="rts-cursor cursor-inner" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor">
                    <span className="fn-left"></span>
                    <span className="fn-right"></span>
                </span>
            </div>

            <div className="modal-sidebar-scroll rts-dark-light">
                <ul>
                    <li className="go-dark-w"><span>Dark</span><i className="rts-go-dark fal fa-moon"></i></li>
                    <li className="go-light-w"><span>Light</span><i className="rts-go-light fa-light fa-brightness"></i></li>
                </ul>
            </div>


        </div>
    )
}

export default WebsiteDevelopment
